

export const colors = {
	'purple':{
    colorRgb:'rgb(106,27,154)',
    colorRgba:'rgba(106,27,154,.7)',
  },
  'red':{
  	colorRgb:'rgb(229,57,53)',
  	colorRgba:'rgba(229,57,53,.7)'
  },
  'green':{
  	colorRgb:'rgb(46,125,50)',
  	colorRgba:'rgba(46,125,50,.7)'
  },
  'blue':{
  	colorRgb:'rgb(13,71,161)',
  	colorRgba:'rgba(13,71,161,.7)'
  },
  'yellow':{
  	colorRgb:'rgb(255,234,0)',
  	colorRgba:'rgba(255,234,0,.7)'
  },
  'black':{
    colorRgb:'rgb(0,0,0)',
    colorRgba:'rgba(0,0,0,.7)'
  },
  'grey':{
    colorRgb:'rgb(158,158,158)',
    colorRgba:'rgba(158,158,158,.7)'
  }
}